import { useEffect, useState } from "react";
import { apiClient } from "../api/apiClient.js";

/**
 * Optional display-only fetch of GET /api/backoffice/agents/{agentId}/profile
 * for the page's "Scope: Agent-BKK-882 · Kittipong A." pill. Guarded on
 * agentId exactly like useInviteCardsList - never fires for a signed-in
 * actor with no owning Agent scope, unlike the shared useAgentProfile hook
 * (which fetches unconditionally on mount, fine for hierarchy drill-down
 * routes where agentId always comes from a URL param, but wrong here where
 * agentId may legitimately be null).
 */
export function useOwningAgentProfile(agentId) {
  const [state, setState] = useState({ status: "idle", data: null, error: null });

  useEffect(() => {
    if (!agentId) {
      setState({ status: "idle", data: null, error: null });
      return undefined;
    }

    let cancelled = false;
    setState({ status: "loading", data: null, error: null });

    apiClient
      .get(`/backoffice/agents/${encodeURIComponent(agentId)}/profile`)
      .then((data) => {
        if (!cancelled) {
          setState({ status: "ready", data, error: null });
        }
      })
      .catch((error) => {
        if (!cancelled) {
          setState({ status: "error", data: null, error });
        }
      });

    return () => {
      cancelled = true;
    };
  }, [agentId]);

  return state;
}
